import Skeleton from '@mui/material/Skeleton';
import PropTypes from 'prop-types';
import React from 'react';

const QSkeleton = (props) => {
  const { show, children, ...otherProps } = props;
  if (show) {
    return (
      <Skeleton {...otherProps}>
        <span>{children || null}</span>
      </Skeleton>
    );
  }
  return children || null;
};

QSkeleton.propTypes = {
  show: PropTypes.bool.isRequired,
  children: PropTypes.node || PropTypes.array,
};

export default QSkeleton;
